import type { User } from '@/types/user'

type ImageCreditsUser = Pick<User, 'experience_variant' | 'capabilities'> | null | undefined

/**
 * Image generation credits are agency-only (full SaaS). Mobile consumer accounts
 * do not generate images; hide purchase UI and balance displays when false.
 */
export function imageCreditsEnabledForUser(user: ImageCreditsUser): boolean {
    if (!user) return true
    if (user.experience_variant === 'mobile_consumer') return false
    if (user.capabilities?.can_purchase_image_credits === false) return false
    return true
}
